import { io } from 'socket.io-client';
const URL = 'https://collegecentral-server.onrender.com';
//const URL = 'http://localhost:3500';

export const socket= io(URL, {
  autoConnect: false,
});


